
function Topo() {
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-4 col-md-offset-4" style={{marginTop:'70px'}}>
                    <br/>
                    <img src={'../../../public/assets/logoupbusca.png'} style={{marginBottom:'-10px', marginTop: '-15px'}} alt="Up Busca" className="center-block img-responsive" id="logo"/>
                </div>
                
            </div>
            <div className="row">

               

                </div>
        </div>
    );
}

export default Topo;
